import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';
import { authFeatureKey } from './auth.reducers';

export const selectAuthState = createFeatureSelector<AuthState>(authFeatureKey);

export const selectAuth = createSelector(selectAuthState, (state: AuthState) => state);